import { css, Inline, Spinner, styled } from 'canoe';
import React from 'react';

import {
  CardSubtitle,
  CardTitle,
  DownloadTooltip,
  HelpTooltip,
  RefreshTooltip,
} from '../Typography';

const GraphWrapper = styled.div<{ minHeight: string | number }>`
  ${({ theme, minHeight }) => css`
    margin-top: ${theme.spaces.l};

    .recharts-responsive-container {
      min-height: ${typeof minHeight === 'string' ? minHeight : `${minHeight}px`};
    }
  `}
`;

interface GraphEmbedProps {
  title?: string;
  subtitle?: string | JSX.Element;
  tooltipText?: string;
  executedAt?: number;
  children?: React.ReactNode;
  onDownloadData?: () => Promise<void>;
  onRefreshQuery?: () => Promise<void>;
  isLoading?: boolean;
  width?: string | number;
  height?: string | number;
}

export const GraphEmbed = ({
  title,
  subtitle,
  tooltipText,
  executedAt,
  children,
  onDownloadData,
  onRefreshQuery,
  isLoading = false,
  width = '100%',
  height = 200,
}: GraphEmbedProps) => {
  return (
    <>
      {(title || subtitle || tooltipText || onDownloadData || (executedAt && onRefreshQuery)) && (
        <Inline justify="space-between">
          <Inline space="xxs" align="center">
            {title && <CardTitle mb={subtitle ? 'xxs' : undefined}>{title}</CardTitle>}
            {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
            {tooltipText && <HelpTooltip>{tooltipText}</HelpTooltip>}
          </Inline>

          <Inline space="none" align="center">
            {onDownloadData && <DownloadTooltip onClick={onDownloadData} />}
            {executedAt && onRefreshQuery && (
              <RefreshTooltip date={executedAt * 1000} onClick={onRefreshQuery} />
            )}
          </Inline>
        </Inline>
      )}

      <div style={{ width, height, minHeight: height, position: 'relative' }}>
        {isLoading ? (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spinner size="large" />
          </div>
        ) : null}

        {!isLoading && children ? <GraphWrapper minHeight={height}>{children}</GraphWrapper> : null}
      </div>
    </>
  );
};
